import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(2),
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    margin: theme.spacing(0, -2),
    borderRadius: theme.shape.borderRadius,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.grey[50],
    },
    "&:last-child": {
      borderBottom: "none",
    },
  },
}));
